<template>
  <div>
    <img src="@/assets/bg1.png" alt="background" style="display:block;border-radius:10px; margin:20px auto; width: 80%">
    <div style="margin: 5px;text-align: center">

      <!--      绑定开始-->
      <div v-if="bindInfo.bindType!==undefined">
        <div v-if="bindInfo.bindType==='Student'">
          <el-tag type="success">已绑定学号姓名：{{ bindInfo.name }} {{ bindInfo.xh }}</el-tag>
          <br>
          <el-button style="margin: 5px" type="mini" @click="$router.push('/CancelBind')">删除绑定</el-button>
          <div>
            <div v-if="bindInfo.phone===''||bindInfo.phone===null">
              <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">绑定联系方式</el-button>
            </div>
            <div v-else-if="bindInfo.phone!==''&&bindInfo.phone!==null">
              <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">更改联系方式</el-button>
            </div>
          </div>
        </div>
        <div v-if="bindInfo.bindType==='None'">
          <el-tag type="danger">未绑定学号姓名，无法选座</el-tag>
          <br>
          <el-button style="margin: 5px" type="mini" @click="$router.push('/bindXh')">前往绑定（学生）</el-button>
          <el-button style="margin: 5px" type="mini" @click="$router.push('/BindTeacher')">前往绑定（教职工）</el-button>
          <el-button style="margin: 5px" type="mini" @click="$router.push('/TeacherExtendFrom')">从已认证的手机同步身份</el-button>
        </div>
        <div v-if="bindInfo.bindType==='TeacherVerified'">
          <el-tag type="success">已绑定且已认证：{{ bindInfo.name }} {{ bindInfo.affiliation }}</el-tag>
          <br>
          <el-button style="margin: 5px" type="mini" @click="$router.push('/CancelBind')">删除绑定</el-button>
          <el-button style="margin: 5px" type="mini" @click="$router.push('/TeacherExtendTo')">同步身份到另一台手机</el-button>
          <div>
            <div v-if="bindInfo.phone===''||bindInfo.phone===null">
              <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">绑定联系方式</el-button>
            </div>
            <div v-else-if="bindInfo.phone!==''&&bindInfo.phone!==null">
              <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">更改联系方式</el-button>
            </div>
          </div>
        </div>
        <div v-if="bindInfo.bindType==='TeacherUnverified'">
          <el-tag type="warning">已绑定但未认证：{{ bindInfo.name }} {{ bindInfo.affiliation }}</el-tag>
          <el-tag type="warning">请首次前往时携带工作证以备查验</el-tag>
          <br>
          <el-button style="margin: 5px" type="mini" @click="$router.push('/CancelBind')">删除绑定</el-button>
          <el-button style="margin: 5px" type="mini" @click="$router.push('/TeacherExtendTo')">同步身份到另一台手机</el-button>
          <el-button style="margin: 5px" type="mini" @click="$router.push('/VerifyTeacher')">认证</el-button>
          <div>
            <div v-if="bindInfo.phone===''||bindInfo.phone===null">
              <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">绑定联系方式</el-button>
            </div>
            <div v-else-if="bindInfo.phone!==''&&bindInfo.phone!==null">
              <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">更改联系方式</el-button>
            </div>
          </div>
        </div>

      </div>
      <!--      绑定结束-->
    </div>
    <el-button style="margin: 20px auto;display: block" @click="$router.push('/sug')">意见箱</el-button>

    <el-checkbox style="margin: 20px auto;display: block" @change="silentModeChange" v-model="silentMode">隐藏右下角不重要的通知
    </el-checkbox>

  </div>


</template>

<script>
import axios from '@/utils/request'
import {tokenNotExists} from "../utils/auth";

export default {
  name: 'Home',
  data() {
    return {
      bindInfo: {},
      silentMode: this.$store.state.silentMode
    }
  },
  methods: {

    silentModeChange(mode) {
      console.log(mode);
      this.$store.commit("setSilentMode", mode)
    },
    getBindInfo() {
      axios.post("/getBindInfo").then(res => {
        this.bindInfo = res.data.bindInfo
      })
    }
  },
  mounted() {

  },
  created() {

    if (tokenNotExists()) {
      axios.post("/loginTemp").then(() => {
        this.getBindInfo()
      })
    } else {
      this.getBindInfo()
    }

  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.info {
  margin: 0 auto;
  width: 70%;
  text-align: center;
  font-size: 16px;
  color: black;
  /*text-shadow: 0 0 5px black;*/
}
</style>
